<template>
  <v-container grid-list-md pt-0 pb-0>
    <!-- <div style="margin-top:17rem !important" v-if="isLoading">
      <v-layout row wrap flex justify-center align-center fill-height>
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-layout>
    </div> -->

    <!-- <div class=""> -->
    <!-- <v-layout row wrap align-center justify-center>
        <v-flex md12 xs12 sm12> -->
    <!-- <div style="height: calc(100vh - 120px); width: 100%" class="ma-2"> -->
    <l-map
      v-if="showMap"
      :zoom="zoom"
      :center="center"
      :options="mapOptions"
      style="height: calc(100vh - 251px);z-index:0"
      @update:center="centerUpdate"
      @update:zoom="zoomUpdate"
    >
      <l-tile-layer :url="url" :attribution="attribution" />
      <div v-for="(i, index) in listAddress" :key="index">
        <l-marker
          :lat-lng="i.latLng"
          v-if="i.latitude !== null && i.longitude !== null"
        >
          <l-icon
            :icon-url="i.iconUrl"
            :icon-size="dynamicSize"
            :icon-anchor="dynamicAnchor"
            :popup-anchor="popupAnchor"
          />
          <l-popup>
            <span class="font-weight-bold popup-map-header">{{ i.name }}</span>
            <br />
            <span class="popup-map-detail">
              <strong>ที่ตั้ง: </strong>{{ i.address }}
            </span>
            <br />
            <span class="popup-map-detail">
              <strong>โทรศัพท์: </strong> {{ i.phone }}
            </span>
            <br />
            <span class="popup-map-detail">
              <strong>หัวหน้าหน่วยงาน: </strong>
              {{ i.head }}
            </span>
            <br />
            <!-- <span class="fs-16">
              <strong>ตำแหน่ง: </strong> {{ i.ตำแหน่ง }} 
              </span
            ><br /> -->
            <a
              :href="
                'https://www.google.com/maps/search/?api=1&query=' +
                  i.latitude +
                  ',' +
                  i.longitude
              "
              target="_blank"
              ><span class="popup-map-detail">เปิดด้วย Google Map</span></a
            >
            <div @click="innerClick"></div>
          </l-popup>
        </l-marker>
      </div>
    </l-map>

    <!-- Legend Section -->
    <v-card flat class="mt-4 pa-4" color="white" style="border-radius: 12px; border: 1px solid #e0e0e0;">
      <div class="subheading font-weight-bold mb-3">
        คำอธิบายหมุดบนแผนที่
      </div>
      <v-layout row wrap>
        <v-flex v-for="(item, index) in legendItems" :key="index" xs12 sm6 md4 lg3 class="py-1">
          <v-layout align-center row fill-height>
            <div style="flex: 0 0 28px !important;" class="mr-2">
              <v-img :src="item.icon" width="28" height="28" contain></v-img>
            </div>

            <div class="legend-text text-truncate text-xs-left" style="flex: 1 1 auto; min-width: 0;">
              {{ item.label }}
            </div>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>
    <!-- </div> -->
    <!-- </v-flex>
      </v-layout> -->
    <!-- </div> -->
  </v-container>
</template>

<script>
import { LMap, LTileLayer, LMarker, LPopup, LIcon } from "vue2-leaflet";
// import { icon } from "leaflet";
// import address from "../assets/json/address2.json";
export default {
  name: "ComponentHowtoMap",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LIcon,
  },
  data() {
    return {
      zoom: 6,
      center: [13.736717, 100.523186],
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      withPopup: [13.736717, 100.523186],
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
      },
      showMap: true,
      listAddress: [],
      iconSize: 35,
      popupAnchor: [0, -20],
      legendItems: [
        { label: "ศูนย์เพาะชำกล้าไม้", icon: require("../assets/pin1.svg") },
        { label: "ศูนย์ส่งเสริมวนศาสตร์ชุมชน", icon: require("../assets/pin2.svg") },
        { label: "สถานีวนวัฒนวิจัย", icon: require("../assets/pin3.svg") },
        { label: "โครงการอันเนื่องมาจากพระราชดำริและกิจการพิเศษ", icon: require("../assets/pin4.svg") },
        { label: "สถานีเพาะชำกล้าไม้", icon: require("../assets/pin5.svg") },
        { label: "โครงการปรับปรุงป่า", icon: require("../assets/pin6.svg") },
        { label: "ศูนย์วนวัฒนวิจัย", icon: require("../assets/pin7.svg") },
        { label: "อื่นๆ/โครงการอื่นๆ", icon: require("../assets/pin.svg") },
      ],
    };
  },
  computed: {
    dynamicSize() {
      return [this.iconSize, this.iconSize * 1.15];
    },
    dynamicAnchor() {
      return [this.iconSize / 2, this.iconSize * 1.15];
    },
  },
  created() {
    this.$emit("activeMenu", "howto");
    this.queryAddressNursery();
  },
  methods: {
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    showLongText() {
      this.showParagraph = !this.showParagraph;
    },
    innerClick() {
      alert("Click!");
    },
    queryAddressNursery() {
      // console.log(address);
      // this.listAddress = address;
      this.axios
        .post(process.env.VUE_APP_IPFLASK + "/queryAddressNursery")
        .then((response) => {
          // console.log(response.data);
          this.listAddress = response.data.map((item) => ({
            ...item,
            iconUrl: this.setIcon(item.status),
            latLng: this.setFormat(item.latitude, item.longitude),
          }));
          // this.isLoading = false;
        });
    },
    setFormat(lat, lng) {
      if (lat !== null && lng !== null) {
        return [lat, lng];
      }
    },
    setIcon(status) {
      const pinMap = {
        "ศูนย์เพาะชำกล้าไม้": require("../assets/pin1.svg"),
        "ศูนย์ส่งเสริมวนศาสตร์ชุมชน": require("../assets/pin2.svg"),
        "สถานีวนวัฒนวิจัย": require("../assets/pin3.svg"),
        "โครงการอันเนื่องมาจากพระราชดำริและกิจการพิเศษ": require("../assets/pin4.svg"),
        "สถานีเพาะชำกล้าไม้": require("../assets/pin5.svg"),
        "โครงการปรับปรุงป่า": require("../assets/pin6.svg"),
        "ศูนย์วนวัฒนวิจัย": require("../assets/pin7.svg"),
      };
      return pinMap[status] || require("../assets/pin.svg");
    },
  },
};
</script>

<style scoped>
.lineheight {
  line-height: 0.65 !important;
}
.lineheight30 {
  line-height: 40px !important;
}

.popup-map-header {
  font-family: "Chakra Petch", sans-serif;
  font-size: 16px;
}

.popup-map-detail {
  font-family: "Chakra Petch", sans-serif;
  font-size: 14px;
}

.legend-text {
  font-family: "Chakra Petch", sans-serif;
  font-size: 14px;
  color: #455a64;
  line-height: 1.2;
}
</style>
